import { withParams, req } from 'vuelidate/lib/validators/common'
export * from 'vuelidate/lib/validators'

export const numAndLetter = withParams({ type: 'numAndLetter' }, value =>
  /^(?=.*[0-9])(?=.*[a-zA-Z])([0-9A-Za-z]{3,})$/i.test(value)
)
export const phone = withParams({ type: 'phone' }, value =>
  /^1[3|4|5|6|7|8|9]\d{9}$/i.test(value)
)
export const equalTo = length =>
  withParams(
    { type: 'equalTo', length },
    value => !req(value) || (!/\s/.test(value) && value.length === length)
  )
export const noZero = withParams({ type: 'noZero' }, value => +value !== 0)
